const BASE_URL = process.env.API_URL + "/nutritionist/notes";


const getAllNotes = (context , userId) => {
  return new Promise((resolve , reject) => {
    context.$http.get(BASE_URL +"/list/" + userId )
      .then((response) => resolve(response.body),
        (error) => reject(error));

  });
};

const createNote = (context , userId, data) => {
  return new Promise((resolve , reject) => {
    context.$http.post(BASE_URL +"/create/" +userId, data)
      .then((response) => resolve(response.body),
        (error) => reject(error));

  });
};


const updateNote = (context , noteId, data) => {
  return new Promise((resolve , reject) => {
    context.$http.put(BASE_URL + "/update/" + noteId , data)
      .then((response) => resolve(response.body),
        (error) => reject(error));

  });
};

const removeNote = (context , noteId) => {
  return new Promise((resolve , reject) => {
    context.$http.delete(BASE_URL + "/delete/" + noteId)
      .then((response) => resolve(response.body),
        (error) => reject(error));

  });
};

export default { getAllNotes , createNote , updateNote , removeNote };



// WEBPACK FOOTER //
// ./src/brand/health/api/nutritionistNotes/index.js